module.exports = __webpack_public_path__ + "static/media/how-it-works-step-1-student.a1689dd9.jpg";